var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',{staticClass:"text-center"},[_c('b',[_vm._v("Welcome, "+_vm._s(_vm.authUser.name))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }